import React, {useEffect} from "react";
import "./testimonial.css";
import allenMaurya from "assets/testimonial/allen_maurya.png";
import dhaneshYadav from "assets/testimonial/dhanesh_yadav.png";
import johnsonRoy from "assets/testimonial/johnson_roy.png";
import sumitSingh from "assets/testimonial/sumit_singh.png";
import jyotiKushwaha from "assets/testimonial/jyoti_kushwaha.png";
import saraReddy from "assets/testimonial/sara_reddy.png";
import Meta from "utils/meta";

const Testimonial = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (<div className="testimonial-container">
            <Meta title="Testimonial | The Realtor Desk" description=""/>
            <div className="container">
                <div className="main-heading">
                    <h1>Customer Testimonials</h1>
                    <h2>Realtor CRM is trusted by over 250,000 businesses worldwide.</h2>
                    <p>Here's what some of our customers say about our platform.</p>
                </div>
                <div className="testimonial-items--outer">
                    <ul className="testimonial-items">
                        <li className="testimonial-item">
                            <div className="customer-review--outer">
                                <p className="customer-review--text">
                                    We switched to Realtor CRM from Salesforce at the
                                    beginning of the 2018 year. It's used track both
                                    prospects, clients, sales, referrals, etc. It's used
                                    by Sales, Billing, and Account Management. It helps
                                    with tracking and analytics for our Sales. It
                                    automates some processes such email campaigns and
                                    custom templates.
                                </p>
                            </div>
                            <div className="customer-review--info">
                                <div className="customer-review--personal">
                                    <span className="customer-name">Mr. Allen Maurya</span>
                                    <span className="customer-designation">Account Manager, Zoho</span>
                                </div>
                                <div className="customer-img">
                                    <img src={allenMaurya} alt="Mr. Allen Maurya" />
                                </div>
                            </div>
                        </li>
                        <li className="testimonial-item">
                            <div className="customer-review--outer">
                                <p className="customer-review--text">
                                    Realtor CRM is used across our entire organization,
                                    with our sales department using the software most
                                    frequently. Realtor CRM acts a database for all of
                                    our leads, contacts, and clients. We use the
                                    software to ensure that our sales staff, engineers,
                                    and consultants all have visibility on where clients
                                    are in the sales process.
                                </p>
                            </div>
                            <div className="customer-review--info">
                                <div className="customer-review--personal">
                                    <span className="customer-name">Ms. Jyoti Kushwaha</span>
                                    <span className="customer-designation">Customer Executive, ATO</span>
                                </div>
                                <div className="customer-img">
                                    <img src={jyotiKushwaha} alt="Ms. Jyoti Kushwaha" />
                                </div>
                            </div>
                        </li>
                        <li className="testimonial-item">
                            <div className="customer-review--outer">
                                <p className="customer-review--text">
                                    Realtor CRM is used here at the head office by every
                                    employee and all of our franchisees across Canada
                                    use it as well. All of our data from sellers/buyers
                                    are store in Zoho. It is used for multiple reasons
                                    such as booking appointments for a franchisee,
                                    sending out important emails to our sellers and
                                    tracking sales.
                                </p>
                            </div>
                            <div className="customer-review--info">
                                <div className="customer-review--personal">
                                    <span className="customer-name">Mr. Dhanesh Yadav</span>
                                    <span className="customer-designation">Marketing Coordinator, ATO</span>
                                </div>
                                <div className="customer-img">
                                    <img src={dhaneshYadav} alt="Mr. Dhanesh Yadav" />
                                </div>
                            </div>
                        </li>
                        <li className="testimonial-item">
                            <div className="customer-review--outer">
                                <p className="customer-review--text">
                                    Realtor CRM is used in our sales department. We use
                                    it to reach out to those who visit our website. It's
                                    helpful to see where the visitor is from and it's
                                    nice to be able to send them messages. By using Zoho
                                    we are now able to get in touch with website
                                    visitors and create potential business for inbound.
                                    The ability to send messages to the website
                                    visitors.
                                </p>
                            </div>
                            <div className="customer-review--info">
                                <div className="customer-review--personal">
                                    <span className="customer-name">Mr. Johnson Roy</span>
                                    <span className="customer-designation">Software Engineer, ATO</span>
                                </div>
                                <div className="customer-img">
                                    <img src={johnsonRoy} alt="Mr. Johnson Roy" />
                                </div>
                            </div>
                        </li>
                        <li className="testimonial-item">
                            <div className="customer-review--outer">
                                <p className="customer-review--text">
                                    We have chosen Realtor CRM as our one-stop-shop for
                                    our business needs. We are able to customize every
                                    aspect of our workflow thanks to its different
                                    modules. Despite its low price tag, Realtor CRM is a
                                    robust, evolved tool, ready for deployment in any
                                    business that values the ability to keep track over
                                    its sales or client outreach pipeline.
                                </p>
                            </div>
                            <div className="customer-review--info">
                                <div className="customer-review--personal">
                                    <span className="customer-name">Ms. Sara Reddy</span>
                                    <span className="customer-designation">Sales Associate, ATO</span>
                                </div>
                                <div className="customer-img">
                                    <img src={saraReddy} alt="Ms. Sara Reddy" />
                                </div>
                            </div>
                        </li>
                        <li className="testimonial-item">
                            <div className="customer-review--outer">
                                <p className="customer-review--text">
                                    It is being used by the sales department as a data
                                    center contact tool with active and potential
                                    customers, and through it the analysts can interact
                                    with their database that is very complete intuitive
                                    to see the statistical reports about the customers
                                    they frequent and program better communication flows
                                    and convert those contacts into sales.
                                </p>
                            </div>
                            <div className="customer-review--info">
                                <div className="customer-review--personal">
                                    <span className="customer-name">Mr. Sumeet Singh</span>
                                    <span className="customer-designation">Project Administrator, ATO</span>
                                </div>
                                <div className="customer-img">
                                    <img src={sumitSingh} alt="Mr. Sumit Singh" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>);
};

export default Testimonial;
